module.exports = __webpack_public_path__ + "static/media/16UNODC25.612212d9.jpg";